function toggleSearch() {
  const search = document.querySelector("[data-search-trigger]");
  const form = document.querySelector("[data-search-form]");
  const close = document.querySelector("[data-search-close]");
  const input = document.querySelector("[data-search-form-input]");

  if (document.body.clientWidth < 1000) {
    search.addEventListener("click", function (event) {
      if (!form.classList.contains("is-open")) {
        event.preventDefault();
        const header = document.getElementById("shopify-section-header");
        document.documentElement.style.setProperty("--navigation-height", `${header.offsetHeight}px`);
        form.classList.add("is-open");
        close.classList.remove("hidden");
        search.classList.add("hidden");
        input.focus();
      }
    });
  }

  close.addEventListener("click", function (event) {
    event.preventDefault();
    form.classList.remove("is-open");
    search.classList.remove("hidden");
    close.classList.add("hidden");
  });
}
toggleSearch();
